import { render, staticRenderFns } from "./page-element-footer-logo.vue?vue&type=template&id=b7177060&scoped=true"
import script from "./page-element-footer-logo.vue?vue&type=script&lang=js"
export * from "./page-element-footer-logo.vue?vue&type=script&lang=js"
import style0 from "./page-element-footer-logo.vue?vue&type=style&index=0&id=b7177060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7177060",
  null
  
)

export default component.exports